import { Button } from "melco-ui";
import { useTranslation } from "react-i18next";


type UserDetailProfileButtonProps = {

  setIsUserProfileDrawerOpenAction: (v: boolean) => void;
};

export const UserDetailProfileButton: React.FC<
  UserDetailProfileButtonProps
> = ({ setIsUserProfileDrawerOpenAction }) => {
  const { t } = useTranslation();

  return (
    <>
      {
        <Button
          key="user-detail-profile"
          type="primary"
          onClick={async () => {
            setIsUserProfileDrawerOpenAction(true)
          }}

        >
          {t("users.profiledetails.button")}
        </Button>
      }
    </>


  );
};
